<template>
  <div class="footer">
    <div class="footer-container">
      <img
        class="footer-logo"
        src="/assets/footer_logo.png"
        alt="엘지 유플러스 로고"
      />
      <div class="copyright">
        <ul class="copyright-menu">
          <li>
            <a title="새창열림" target="_blank" tabindex="0" @click="clickTerms"
              >이용약관</a
            >
          </li>
          <li>
            <a
              title="새창열림"
              target="_blank"
              href="https://www.lguplus.com/footer/privacy-policy"
              ><em class="bold-text">개인정보처리방침</em></a
            >
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="0" @click="rejectCollectingEmailPopup"
              >이메일주소 무단수집거부</a
            >
          </li>
        </ul>
        <br />
        <div>
          <ul>
            <li>
              <em class="bold-text">(주)엘지유플러스</em><span> 주소</span>
              <address>서울특별시 용산구 한강대로 32</address>
            </li>
            <li><span class="bold-text">대표이사</span> 홍범식</li>
            <li><span class="bold-text">사업자 등록번호</span> 220-81-39938</li>
          </ul>
          <ul>
            <li>
              <span class="bold-text">무선 고객센터</span> 1544-0010(유료)
            </li>
          </ul>
        </div>
        <br />
        <p>COPYRIGHT (C) LG Uplus Corp.</p>
      </div>
      <RejectCollectingEmailPopup />
    </div>
  </div>
</template>

<script>
import RejectCollectingEmailPopup from './../openMarket/popup/RejectCollectingEmailPopup'
export default {
  name: 'ConnectedCarFooter',

  components: {
    RejectCollectingEmailPopup
  },

  methods: {
    /** 
     * Function    : clickTerms
     * Description : 약관 클릭 시 팝업 호출
     **/
    clickTerms() {
      let routeData = this.$router.resolve({ name: 'ConnectedCarTerms' })
      window.open(
        routeData.href,
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
      )
    },

    /** 
     * Function    : rejectCollectingEmailPopup
     * Description : 이메일주소 무단수집거부 클릭 시 팝업 호출
     **/
    rejectCollectingEmailPopup() {
      this.$modal.show('RejectCollectingEmail')
    },
  }
}
</script>

<style scoped></style>
